export const ROLES = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADMIN: 'ADMIN',
    USER: 'USER',
    GUEST: 'GUEST',
    UNAUTHORIZED: 'UNAUTHORIZED',
};
//# sourceMappingURL=constants.js.map